<div
  fxLayout="col {{ extra_layout }}"
  fxLayoutAlign="{{ layout_alignment }}"
  fxLayoutGap="{{ layout_gap }}"
  fxFlex="{{ flex }}"
>
  <template #clayout></template>
</div>
